export const selectionTypes = {
    GROUP: 'groups',
    GROUPMULTIPLE: 'groupmultiple',
    CAMPAIGN: 'campaign',
    CHANNEL: 'channel',
    MESSAGESQUEUE: "messagesqueue"

};

export const channels = [
    { id: "", name: "all2" },
    { id: "chat", name: "Chat" },
    { id: "facebook", name: "Facebook" },
    { id: "instagram", name: "Instagram" },
    { id: "twitter", name: "X" },
    { id: "whatsapp", name: "Whatsapp" },
    { id: "sms", name: "SMS" },
    { id: "rainbow", name: "Rainbow" },
    { id: "telegram", name: "Telegram" },
    { id: "mail", name: "Mail" }
];
  
export const channelsKeys = {
    CHAT: "chat",
    FIDELITY: "fidelity",
    FACEBKOOK: "facebook",
    INSTAGRAM: "instagram",
    TWITTER: "twitter",
    WHATSAPP: "whatsapp",
    SMS: "sms",
    RAINBOW: "rainbow",
    TELEGRAM: "telegram",
    MAIL: "mail"
}
export const statusColors = {
    "free": "success",
    "loggedout": "secondary",
    "paused": "danger",
    "wrapup": "warning"
};
export const hourFormat = "HH:mm";

